import React from 'react';
import { Route } from 'react-router-dom';
import './MainWindow.scss';

import Stations from '../Stations';
import Comments from '../Comments';
import Users from '../Users';
import {isAdminUser} from "../../helpers/helpers";

const MainWindow = () => {

    return (
        <div className='mainWindow' >
            <Route
                exact path='/'
                render={props =>
                    <Stations
                        {...props}
                    />
                }
            />
            <Route
                exact path='/comments'
                render={props =>
                    <Comments
                        {...props}
                    />
                }
            />
            {isAdminUser() &&
                <Route
                    exact path='/users'
                    render={props =>
                        <Users
                            {...props}
                        />
                    }
                />
            }
        </div>
    );

};

export default MainWindow;
